angular.module("dx.webapp.share", []);
